/// <reference lib="webworker" />

//import * as Excel from "exceljs";

import * as Excel from 'exceljs/dist/exceljs.min.js'


addEventListener('message', ({ data }) => {
  try {
    var reader = new FileReaderSync();
    postMessage({
      name: data.name,
      result: reader.readAsDataURL(data),
      size: data.size
    });
  } catch (e) {
    postMessage({
      result: 'error'
    });
  }
});


 


